import { boardBackTarget } from "./board-back-target.ts";

// These are routed list/detail families, not every URL with multiple segments.
// Explicit parents avoid nonexistent URLs and browser-history/tab loops.
const detailLists = [
  "/agent-builder/credentials",
  "/agent-builder/connectors",
  "/agent-builder/mcp-servers",
  "/agent-builder/missions",
  "/agent-builder/tool-builder",
  "/agent-builder/serverless-functions",
  "/agent-builder/model-registry",
  "/agent-builder/credential-registry",
  "/live/orchestrators",
  "/live/webhooks",
  "/platform-settings/roles-permissions",
  "/platform-settings/projects",
  "/super-admin/statistics",
  "/super-admin/license",
  "/super-admin/transactions",
  "/marketplace/cookbook",
];

export function pageBackTarget(pathname: string): string | null {
  const path = pathname.replace(/\/+$/, "");
  const board = boardBackTarget(path);
  if (board) return board;

  const providerAccess = path.match(/^\/agent-builder\/tool-builder\/providers\/([^/]+)\/accessibility$/);
  if (providerAccess) {
    try {
      return `/agent-builder/tool-builder?provider=${encodeURIComponent(decodeURIComponent(providerAccess[1]))}`;
    } catch {
      return "/agent-builder/tool-builder";
    }
  }

  const channel = path.match(/^\/live\/channels\/([^/]+)\/[^/]+(?:\/.*)?$/);
  if (channel) {
    const lists: Record<string, string> = {
      targeted: "targeted-channels",
      secure: "encrypted-channels",
      broadcast: "broadcast-channels",
      group: "group-channels",
      "shared-object": "shared-object-channels",
    };
    return lists[channel[1]] ? `/live/${lists[channel[1]]}` : null;
  }
  if (/^\/super-admin\/tenants\/[^/]+(?:\/.*)?$/.test(path))
    return "/super-admin/tenant_list";
  if (
    /^\/application-settings\/connections\/profile-insight\/[^/]+$/.test(path)
  )
    return "/application-settings/connections";

  const template = path.match(
    /^(\/application-settings\/email-config\/[^/]+\/templates)\/[^/]+$/,
  );
  if (template) return template[1];
  if (path.startsWith("/application-settings/email-config/"))
    return "/application-settings/messaging/email";

  return detailLists.find((list) => path.startsWith(`${list}/`)) ?? null;
}

export function pageBackLabel(target: string): string {
  if (target.startsWith("/agent-builder/tool-builder?provider=")) return "Back to provider";
  if (target.endsWith("?tab=runtime")) return "Back to runtime";
  const segment = target.split("/").pop() || "previous page";
  const labels: Record<string, string> = {
    tenant_list: "tenants",
    email: "email configuration",
    cookbook: "marketplace",
  };
  return `Back to ${labels[segment] || segment.replace(/[-_]/g, " ")}`;
}
